import { ChangeDetectionStrategy, Component, EventEmitter, Output, signal, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';

interface TimeState {
  hours: number;
  minutes: number;
}

@Component({
  selector: 'app-task-view-comments-time',
  templateUrl: './task-view-comments-time.component.html',
  styleUrls: ['./task-view-comments-time.component.less'],
  imports: [FormsModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskViewCommentsTimeComponent {
  @Output() save = new EventEmitter<number>();

  private readonly state = signal<TimeState>({
    hours: 0,
    minutes: 0,
  });

  protected readonly hours = computed(() => this.state().hours);
  protected readonly minutes = computed(() => this.state().minutes);

  onSetHour(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.state.update(state => ({
      ...state,
      hours: +value || 0,
    }));
  }

  onSetMinute(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.state.update(state => ({
      ...state,
      minutes: +value || 0,
    }));
  }

  onSubmit(): void {
    const { hours, minutes } = this.state();
    const time = hours + Math.floor((minutes / 60) * 100) / 100;
    this.save.emit(time);
  }
}
